import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { StyledButton } from "../../../components/ListShowButton";
import { useField } from "react-final-form";
import { find, findIndex } from "lodash";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface RemoveUnAssignedLocationButtonProps {
  routeLocationId: number;
}

const RemoveUnAssignedLocationButton: React.FC<
  RemoveUnAssignedLocationButtonProps
> = ({ routeLocationId }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedRouteLocation, setSelectedRouteLocation] = useState<any>(null);

  const droppedLocationsField = useField("droppedLocations");
  const formRoutesChangedField = useField("formRoutesChanged");

  const classes = useStyles();

  const handleOpenDialog = () => {
    const findRouteLocation = find(droppedLocationsField.input.value, [
      "id",
      routeLocationId,
    ]);
    setSelectedRouteLocation(findRouteLocation);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveRemoveUnAssignedLocation = () => {
    const findRouteLocationIndex = findIndex(
      droppedLocationsField.input.value,
      ["id", routeLocationId],
    );

    droppedLocationsField.input.onChange([
      ...droppedLocationsField.input.value.slice(0, findRouteLocationIndex),
      ...droppedLocationsField.input.value.slice(findRouteLocationIndex + 1),
    ]);
    formRoutesChangedField.input.onChange(true);

    handleClose();
  };

  return (
    <>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Remove
      </StyledButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Remove {selectedRouteLocation?.address}
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to remove this unassigned location?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleSaveRemoveUnAssignedLocation}
            color="primary"
            label="Save"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveUnAssignedLocationButton;
